<div class="col-md-{{ question.colSize }} my-2">
  <form [formGroup]="formData">
    <label>{{ question.label }}</label>
    <br />
    <ng-container *ngFor="let option of question.options">
      <ng-container *ngFor="let item of option.jsonValue | keyvalue">
        <div
          class="form-check form-check-inline form-checkbox-outline form-check-primary mb-1">
          <input
            [formControlName]="item.key"
            class="form-check-input"
            type="checkbox"
            id="{{ question.name }}-{{ item.key }}" />
          <label
            class="form-check-label"
            for="{{ question.name }}-{{ item.key }}">
            {{ item.value }}
          </label>
        </div>
      </ng-container>
    </ng-container>
  </form>
</div>
